import { __module as e } from "../../../_virtual/isLocale.js";
import { a as t } from "./util/assertString.js";
Object.defineProperty(a = e.exports, "__esModule", {
  value: !0
}), a.default = function (e) {
  return (0, r.default)(e), "en_US_POSIX" === e || "ca_ES_VALENCIA" === e || o.test(e);
}, r = t && t.__esModule ? t : {
  default: t
}, o = /^[A-Za-z]{2,4}([_-]([A-Za-z]{4}|[\d]{3}))?([_-]([A-Za-z]{2}|[\d]{3}))?$/, e.exports = a.default, e.exports.default = a.default;
var a,
  r,
  o,
  s = e.exports;
export { s as i };